import React from 'react'
import { Box, Typography, CardContent, Divider } from '@mui/material'
import { StyledCard } from '../../common/StyledCard'
import { getEntityMeta } from '../../../helpers/dashboardHelpers'
import { formatCurrency } from '../../../utils/currencyUtils'

export interface CustomerOrderStatsDto {
  expectedRevenueToday: number
  ordersReceivedToday: number
}

interface CustomerOrderWidgetProps {
  data: CustomerOrderStatsDto
}

const CustomerOrderWidget: React.FC<CustomerOrderWidgetProps> = ({ data }) => {
  const meta = getEntityMeta('CUSTOMER_ORDER')
  const Icon = meta.icon

  return (
    <StyledCard sx={{ height: '100%' }}>
      <CardContent>
        <Box sx={{ display: 'flex', alignItems: 'center', mb: 3 }}>
          <Box
            sx={{
              p: 1,
              borderRadius: 1,
              bgcolor: `${meta.color}15`,
              color: meta.color,
              display: 'flex',
              mr: 2
            }}
          >
            <Icon />
          </Box>
          <Typography variant="h6" sx={{ fontWeight: 'bold' }}>
            {meta.title}
          </Typography>
        </Box>

        <Box sx={{ textAlign: 'center', mb: 2 }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Expected Revenue
          </Typography>
          <Typography variant="h4" sx={{ fontWeight: 'bold', color: 'secondary.main' }}>
            {formatCurrency(data.expectedRevenueToday)}
          </Typography>
        </Box>

        <Divider sx={{ mb: 2 }} />

        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
          <Typography variant="body2" sx={{ color: 'text.secondary' }}>
            Orders Received
          </Typography>
          <Typography variant="subtitle1" sx={{ fontWeight: 'bold' }}>
            {data.ordersReceivedToday}
          </Typography>
        </Box>
      </CardContent>
    </StyledCard>
  )
}

export default CustomerOrderWidget
